<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2 v-if="this.id">Edit</h2> 
                <h2 v-else>Create</h2>
                <h4>Product Category</h4>
            </div>
        </div> 
        <div class="row mt-4">
            <form novalidate="novalidate" @submit.prevent="submit"  class="col col-md-12 border-top border-bottom py-4"> 
                <!--  needs-validation -->
                <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">Name</label> 
                    <div class="col-sm-6">
                        <input type="text" id="name" required="required" autofocus="autofocus" class="form-control"  
                            :class="{'is-invalid': hasError}"
                            v-model="name"
                            :disabled="this.loading" > 
                        <form-error name="name" :errors="errors"></form-error> 
                    </div>
                </div> 
                <div class="form-group row">
                    <div class="col-sm-10 offset-sm-2" v-if="this.id">
                        <button type="submit" class="btn btn-primary" v-if="! this.loading">Edit</button>
                        <button type="submit"  class="btn btn-primary" disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                    <div v-else>
                        <button type="submit" class="btn btn-primary" >Create</button>
                    </div>
                </div> 
                <router-link :to="{name:'productCategories.index'}">Back to List</router-link>
            </form>
        </div>
    </div>
</template>

<script>
import FormError from "../../Util/FormError"
import ProductCategoriesService from "../../../services/ProductCategoriesService"

export default {
    data: function () {
        return {
            loading: false,
            name: '',
            errors: {},
        }
    },

    props: {
        id: {
            default: null,
        },
    },
    
    components: {FormError},

    mounted(){
        if (this.id) {
            this.load();
        }
    },

    watch: {
        id: function () {
            this.load();  
        },
    },

    methods: {
        submit: function () {
            if (this.id === null) {
                ProductCategoriesService.store(this.formData())
                    .then( ({data}) => this.success(data) )
                    .catch( ({response}) => this.failed(response) );
            } else {
                ProductCategoriesService.update(this.id, this.formData())
                    .then( ({data}) => this.success(data) )
                    .catch( ({response}) => this.failed(response) );
            }
        },

        formData: function () {
            return {
                name: this.name, 
            };
        },

        success: function () {            
            window.flash((this.id ? 'Product Category Updated' : 'Product Category Created'));
            this.reset();
            this.$router.push({name: 'productCategories.index'});
        },

        failed: function (response) {
            this.errors = response.data.errors;
        },

        load: function () {
            this.loading = true;
            ProductCategoriesService.get(this.id)
                .then( ({data}) => {
                    this.name = data.data.name;
                    this.loading = false;
                });
        },

        reset: function () {
            this.name = '';
            this.errors = {};
        }
    },

    computed: {
        hasError: function () { return (this.errors['name']); }
    }
}
</script>